import React, { useState, useEffect, Fragment, useCallback } from 'react';
import {
  Drawer, Modal, Popconfirm, Table,
  notification,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import { connect } from 'react-redux';
import ProductActions from '@Actions/productActions';
import './style.scss';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import quickUpdateActions from '../../../../actions/quickUpdate/quickUpdateActions';
import TallyProductSelect from './TallyProductSelect';

const UpdateTallyLedger = ({
  getTallyProducts, tallyProducts, user, getTallyProductsLoading, selectedProduct, callback, quickUpdateEntityWise,
}) => {
  const [productMappings, setProductMappings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isUserReady, setIsUserReady] = useState(false);

  useEffect(() => {
    getTallyProducts(user?.tenant_info?.it_id, user.org_id);
  }, [getTallyProducts, user?.tenant_info?.it_id, user.org_id]);

  useEffect(() => {
    if (selectedProduct?.length && !isUserReady) {
      const initialMappings = selectedProduct?.map((product) => ({
        productSkuId: product?.product_info?.product_sku_id,
        prev_temp_tally_product_id: product?.tally_products?.[0]?.temp_tally_product_id,
      }));
      setIsUserReady(true);
      setProductMappings(initialMappings);
    }
  }, [selectedProduct, isUserReady]);

  const ledgerMappingColumns = () => [
    {
      title: 'Name On Procuzy',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      width: '250px',
      render: (text, record) => (
        <Fragment>
          <H3Text text={`${record?.alias_name} (${record?.uom_info?.uqc})`} />
        </Fragment>
      ),
    },
    {
      title: 'Name On Tally',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      width: '250px',
      render: (text, record) => (
        <Fragment>
          <TallyProductSelect
            record={record}
            tallyProducts={tallyProducts}
            getTallyProductsLoading={getTallyProductsLoading}
            setProductMappings={setProductMappings}
            productMappings={productMappings}
            getTallyProducts={(searchKeyword, selectedProduct) => getTallyProducts(user?.tenant_info?.it_id, user?.org_id, searchKeyword, selectedProduct)}
          />
        </Fragment>
      ),
    },
    {
      title: '',
      width: '50px',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => (
        <Fragment>
          <H3Text
            text={
              (
                productMappings.find((mapping) => mapping.id === record.id)?.tallyUomName
                || tallyProducts?.find((item) => item.product_name === record?.product_info?.tally_product_name)?.base_unit
              ) || '-'
            }
          />
        </Fragment>
      ),
    },
    {
      title: '',
      fixed: 'right',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => (
        <Popconfirm
          title={(
            <React.Fragment>
              Unlinking the product will result in the creation of a new ledger/master in Tally.
              <br />
              To avoid duplication, please proceed with caution.
            </React.Fragment>
          )}
          placement="bottomRight"
          onConfirm={() => {
            setLoading(true);
            const payload = {
              productMappings: [{
                productSkuId: record?.product_sku_id,
                tallyName: '',
                tallyUomName: '',
                prev_temp_tally_product_id: record?.tally_products?.[0]?.temp_tally_product_id,
              }],
              org_id: user?.tenant_info?.org_id,
              entity_name: 'PRODUCT',
            };
            quickUpdateEntityWise(payload, () => {
              setLoading(false);
              callback();
            });
          }}
        >
          <div style={{
            marginLeft: 'auto',
            textDecoration: 'underline',
            color: 'rgb(45, 124, 247)',
          }}
          >
            <H3Text
              text="Unlink"
              className="table-subscript"
            />
          </div>
        </Popconfirm>
      ),
    },
  ];

  const handleUpdate = () => {
    setLoading(true);
    const payload = {
      productMappings,
      org_id: user?.tenant_info?.org_id,
      entity_name: 'PRODUCT',
    };
    if (!productMappings?.[0]?.tallyName) {
      // notification.error({
      //   message: 'Please select product to update',
      //   placement: 'top',
      //   duration: 3,
      // });
      setLoading(false);
      return;
    }
    quickUpdateEntityWise(payload, () => {
      setLoading(false);
      callback();
    });
  };

  return (
    <React.Fragment>
      <Table
        showHeader
        size="small"
        columns={ledgerMappingColumns()}
        bordered
        dataSource={selectedProduct || []}
        pagination={false}
      />
      <div className="custom-drawer__footer flex-display" style={{ width: '100%' }}>
        <H3Button
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          text="Update"
          onClick={handleUpdate}
          style={{
            borderRadius: '5px',
            padding: '9px 15px',
            width: '100px',
          }}
          isLoading={getTallyProductsLoading || loading}
          disabled={getTallyProductsLoading || loading}
        />
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ UserReducers, ProductReducers }) => ({
  user: UserReducers.user,
  org: UserReducers.org,
  tallyProducts: ProductReducers.tallyProducts,
  getTallyProductsLoading: ProductReducers?.getTallyProductsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getTallyProducts: (itId, orgId, searchKeyword, selectedProduct, callback) => dispatch(ProductActions.getTallyProducts(itId, orgId, searchKeyword, selectedProduct, callback)),
  quickUpdateEntityWise: (payload, Callback, rollback) => dispatch(quickUpdateActions.quickUpdateEntityWise(payload, Callback, rollback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateTallyLedger);
